import { render, staticRenderFns } from "./RegexItem.vue?vue&type=template&id=2f29d32c"
import script from "./RegexItem.vue?vue&type=script&lang=js"
export * from "./RegexItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports